import Commons from '../../../../Services/Common/Common';
import dayjs from 'dayjs';
import Store from '../../../../Store/Store';

export const M_TBS_CUSTOM_Schema = {
  mapper: {
    search1: {
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd) || '',
    },
    search2: {
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd) || '',
    },
    search3: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd) || '',
      StartDate: (context) => Commons.EncryptAES(context.startDate) || '',
      EndDate: (context) => Commons.EncryptAES(context.endDate) || '',
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd) || '',
      SearchText: () => Commons.EncryptAES('') || '',
    },
    search4: {
      UserId: (context) => context.userInfo?.userid ?? '',
    },
    search5: {
      UserId: (context) => context.userInfo?.userid ?? '',
    },
    search6: {
      SessionCd: (context) =>
        Commons.EncryptAES(context.sessionCd.toString() ?? ''),
    },
    search7: {
      UserId: (context) => context.userInfo?.userid,
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd || ''),
      StartDate: (context) => Commons.EncryptAES(dayjs().format('YYYY-MM-DD')),
      EndDate: (context) => Commons.EncryptAES(dayjs().format('YYYY-MM-DD')),
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd || ''),
      Status: (context) => Commons.EncryptAES(''),
    },
    search8: {
      UserId: (context) => context.userInfo?.userid,
    },
    save1: {
      SessionCd: (row) => Commons.EncryptAES(row.sessionCd ?? '') || '',
      TbmTitle: (row) => Commons.EncryptAES(row.tbmTitle ?? '') || '',
      CurStepOrder: (row) =>
        Commons.EncryptAES(row.curStepOrder.toString() ?? '0') || '',
      CurStepCode: (row) => Commons.EncryptAES(row.curStepCode ?? '') || '',
      CurPosition: (row) => Commons.EncryptAES(row.curPosition ?? '0') || '',
      IsPlaying: (row) => Commons.EncryptAES(row.isPlaying ?? 'N') || '',
      SessionStatus: (row) =>
        Commons.EncryptAES(row.sessionStatus ?? 'READY') || '',
      HostId: (_, context) => context.userInfo?.userid ?? '',
      CustCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.custCd) || '',
      TbmDate: (row) => Commons.EncryptAES(row.tbmDate ?? '') || '',
      TbmAddress: (row) => Commons.EncryptAES(row.tbmAddress ?? '') || '',
      TbmContent: (row) => Commons.EncryptAES(row.tbmContent ?? '') || '',
      VideoPath: (row) => Commons.EncryptAES(row.videoPath ?? '') || '',
      FilePath: (row) => Commons.EncryptAES(row.filePath ?? '') || '',
      PlanPath: (row) => Commons.EncryptAES(row.planPath ?? '') || '',
      VideoFile: (row) => {
        const file = (row.videoFile ?? [])[0];
        if (!file?.filePath) return null;
        return {
          StepCode: Commons.EncryptAES('TBM_VIDEO') || '',
          ContentOrder:
            Commons.EncryptAES(String(file.contentOrder ?? 0)) || '',
          FilePath: Commons.EncryptAES(file.filePath ?? '') || '',
          FileName: Commons.EncryptAES(file.fileName ?? '') || '',
          SourceType: Commons.EncryptAES(file.sourceType ?? 'EDU_VIDEO') || '',
          SourceId: Commons.EncryptAES(file.sourceId ?? '') || '',
          LastPosition: Commons.EncryptAES(file.lastPosition ?? '0') || '',
        };
      },
      EduFiles: (row) =>
        (row.eduFiles ?? []).map((file) => ({
          StepCode: Commons.EncryptAES('TBM_DOCS') || '',
          ContentOrder:
            Commons.EncryptAES(String(file.contentOrder ?? 0)) || '',
          FilePath: Commons.EncryptAES(file.filePath ?? '') || '',
          FileName: Commons.EncryptAES(file.fileName ?? '') || '',
          SourceType: Commons.EncryptAES('EDU_FILE') || '',
          SourceId: Commons.EncryptAES(file.sourceId ?? '') || '',
          LastPosition: Commons.EncryptAES(file.lastPosition ?? '0') || '',
        })),
      PlanFiles: (row) =>
        (row.planFiles ?? []).map((file) => ({
          StepCode: Commons.EncryptAES('TBM_PLAN') || '',
          ContentOrder:
            Commons.EncryptAES(String(file.contentOrder ?? 0)) || '',
          FilePath: Commons.EncryptAES(file.filePath ?? '') || '',
          FileName: Commons.EncryptAES(file.fileName ?? '') || '',
          SourceType: Commons.EncryptAES('SAF_BASIC') || '',
          SourceId: Commons.EncryptAES(file.sourceId ?? '') || '',
          LastPosition: Commons.EncryptAES(file.lastPosition ?? '0') || '',
        })),
      MeetPath: (row) => Commons.EncryptAES(row.meetPath ?? ''),
      EntryPath: (row) => Commons.EncryptAES(row.entryPath ?? ''),
      SignPath: (row) => Commons.EncryptAES(row.signPath ?? '') || '',
      SignDate: (row) => Commons.EncryptAES(row.signDate ?? '') || '',
      StartDt: (row) => Commons.EncryptAES(row.startDt ?? '') || '',
      EndDt: (row) => Commons.EncryptAES(row.endDt ?? '') || '',
      TotalElapsedTime: (row) =>
        Commons.EncryptAES(row.totalElapsedTime ?? '0') || '',
      SessionSteps: (row) => row.sessionSteps ?? [],
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    save2: {
      SessionCd: (row) =>
        Commons.EncryptAES(row.sessionCd.toString() ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
      CompleteYn: (row) => Commons.EncryptAES(row.completeYn ?? 'N') || '',
      SignImagePath: (row) => Commons.EncryptAES(row.signImagePath ?? '') || '',
      SignDate: (row) => Commons.EncryptAES(row.signDate ?? '') || '',
      IsSkipped: (row) => Commons.EncryptAES(row.isSkipped ?? 'N') || '',
      HostYn: (row) => Commons.EncryptAES(row.hostYn ?? 'N') || '',
      EntranceDt: (row) =>
        Commons.EncryptAES(
          row.entranceDt ?? dayjs().format('YYYY-MM-DD HH:mm:ss')
        ) || '',
      ExitDt: (row) => Commons.EncryptAES(row.exitDt ?? '') || '',
      StayTime: (row) =>
        Commons.EncryptAES(row.stayTime.toString() ?? '0') || '',
    },
  },
};
